import React from 'react';

import {
  SelectedEntities,
} from '../../../components';

import './style.scss';

const ViewRecentEntities = ({ id, entities, title, attr }) => {

  return (
    <SelectedEntities
      id={id}
      type={attr.type}
      link={attr.link}
      entities={entities}
      title={title}
    />
  );
};

export default ViewRecentEntities;
